import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import EntitySidebar from 'components/EntitySidebar';
import SidebarBox from 'components/SidebarBox';
import FlightStatus from 'components/FlightStatus';
import Packages from 'components/FlightSidebarPackages';

import { FlightSidebar_flight$key } from '__generated__/FlightSidebar_flight.graphql';
import { Divider } from '@mui/material';

type Props = {
  flight: FlightSidebar_flight$key;
};

const FlightSidebar: FC<Props> = props => {
  const flight = useFragment(
    graphql`
      fragment FlightSidebar_flight on Flight {
        ...EntitySidebar_entity
        ...FlightStatus_flight
        ...FlightSidebarPackages_flight
      }
    `,
    props.flight
  );

  return (
    <EntitySidebar entity={flight}>
      <SidebarBox label="Būsena:">
        <FlightStatus flight={flight} />
      </SidebarBox>

      <Divider />

      <SidebarBox label="Naudojamas pasiūlymuose:">
        <Packages flight={flight} />
      </SidebarBox>
    </EntitySidebar>
  );
};

export default FlightSidebar;
